<template>
   <div class="w-1200 release-wp">
       <div class="r-tip">
            <p :class="currentColumn=='发布中心'?'clickp':''" @click="changeColumn('发布中心')">发布中心</p>
            <p :class="currentColumn=='示范发布'?'clickp':''" @click="changeColumn('示范发布')">示范发布</p>
            <p :class="currentColumn=='装备发布'?'clickp':''" @click="changeColumn('装备发布')">装备发布</p>
            <p :class="currentColumn=='技术发布'?'clickp':''" @click="changeColumn('技术发布')">技术发布</p>
        </div>
        <div class="release-center" style="height:auto;"  v-if="currentColumn=='发布中心'&&columnType==1">
            <div class="w-950 r-1"> 
                
                <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t">示范进展</p>
                    <!-- <p class="t-m-m">MORE +</p> -->
                </div>
                <div class="box-bottom">
                    <div class="r-r-1-img">
                        <el-carousel indicator-position="none" height="300px">
                            <el-carousel-item v-for="(item,index) in imgs" :key="index" @click.native="getDetail('示范发布',item.id)">
                                
                               <el-image style="width: 100%; height: 100%;" :src="item.path" fit="contain" >
                                    <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                        <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                    </div> -->
                                </el-image>
                                <p class="img-title p-lv">{{item.title}}</p>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="r-r-1-items">
                        <div class="i-box"> 
                            <div class="item" v-for="(item,index) in sffb" :key="index" @click="getDetail('示范发布',item.id)">
                                <p class="i-title p-lv pointer">{{item.infoTitle}}</p>
                                <p class="i-time">{{item.modifyDate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-950 r-2 m-t-10">
                <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t">装备发布</p>
                    <!-- <p class="t-m-m">MORE +</p> -->
                </div>
                <div class="box-bottom">
                    <div class="item" v-for="(item,index) in zbfb" :key="index" @click="getDetail('装备发布',item.id)">
                        <div class="img">
                            <el-image style="width: 150px; height: 122px;" :src="item.sctp" fit="contain" >
                                <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                </div> -->
                            </el-image>
                            <!-- <img :src="item.sctp"> -->
                        </div>
                        <div class="content">
                            <p class="p1 p-lv pointer">{{item.infoTitle}}</p>
                            <p class="p2 p-lv-2">{{item.zbcxd}}
                                </p>
                            <p class="p3"><span>{{item.fgdwStr}}</span> {{item.modifyDate}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-950 r-3 m-t-10">
                <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t">技术发布</p>
                    <!-- <p class="t-m-m">MORE +</p> -->
                </div>
                <div class="bottom">
                    <el-row :gutter="10">
                        <el-col :span="6" v-for="(item,index) in jsfb" :key="index">
                            <div class="item pointer"  @click="getDetail('技术发布',item.id)">
                            <el-image class="img" :src="item.sctp" fit="contain" >
                                <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                </div> -->
                            </el-image>
                            <!-- <img :src="item.sctp"> -->
                            <p class="p1 p-lv pointer">{{item.infoTitle}}</p>
                            <p class="p2 p-lv-2">{{item.abstratc}}</p>
                        </div>
                        </el-col>
                    </el-row>
                        
                    
                </div>
            </div>
        </div>
        <div class="example-release" v-if="(currentColumn=='示范发布'||currentColumn=='装备发布'||currentColumn=='技术发布')&&columnType==1">
            <div class="w-950 e-r-1">
                <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t">{{currentColumn}}</p>
                </div>
                 <div class="box-bottom">
                    <div v-for="(item,index) in releaseList" :key="index" class="item pointer" @click="getDetail('',item.id)">
                        <div class="img">
                            <!-- <img :src="item.sctp"> -->
                            <el-image style="width: 100%; height: 100%;" :src="item.sctp" fit="contain" >
                                <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                </div> -->
                            </el-image>
                        </div>
                        <div class="content">
                            <p class="p1 p-lv">{{item.infoTitle}}</p>
                            <p class="p2 p-lv-2">{{item.abstratc}}</p>
                            <p class="p3"><span>{{item.fgdwStr}}</span><span> {{item.modifyDate}}</span></p>
                        </div>
                    </div>
                    <z-page :pageObj="page" @changePage1="changePage1"></z-page>
                 </div>
            </div>
        </div>
        <div class="w-950 e-d-1" v-if="columnType==2">
            <div class="title-more">
                <div class="t-m-blue"></div>
                <p class="t-m-t">{{currentColumn}}</p>
            </div>
            <div class="box-bottom">
                <div style="width:calc(100% - 40px);height:calc(100% - 40px);padding:20px;">
                    <div class="b-1">
                        <div class="img">
                            <el-image style="width: 100%; height: 100%;" :src="releaseDetail.sctp" fit="contain" >
                                 <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                    </div> -->
                            </el-image>
                            <!-- <img :src="releaseDetail.sctp"> -->
                        </div>
                        <div class="b-c">
                            <p class="p1 p-lv-2">{{releaseDetail.infoTitle}}</p>
                            <p class="p2">{{releaseDetail.fgdw}}</p>
                            <p class="p3">{{releaseDetail.yjnr}}</p>
                        </div>
                    </div>
                    <div class="b-2" v-for="(item,index) in detailTitle" :key="index">

                        <div class="b-2-t" >
                            <div></div><p >{{item.title}}</p>
                            
                        </div>
                        <div class="b-2-c">
                            <p v-if="item.key!='fbnr'">{{releaseDetail[item.key]}}</p>
                            <com-richtext v-if="item.key=='fbnr'" :richtext="releaseDetail[item.key]"></com-richtext>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>
<script>
import Release from './Release.js';
export default Release;
</script>
<style lang="scss" scoped>
@import './Release.scss';
</style>